import { render, staticRenderFns } from "./HomeSideAdsContainer.vue?vue&type=template&id=45b94eae&scoped=true&"
import script from "./HomeSideAdsContainer.vue?vue&type=script&lang=js&"
export * from "./HomeSideAdsContainer.vue?vue&type=script&lang=js&"
import style0 from "./HomeSideAdsContainer.vue?vue&type=style&index=0&id=45b94eae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b94eae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VImg})
